import ScrollButton from '../components/scroll_button';
import InfoSection from '../components/info_section';
import Layout from '../components/layout';
import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import Image from 'next/image';
import { functionOutrunServiceList, caseList, benefitList, relatedServices } from '../constants/outrunService';
import styles from '../styles/outrunService.module.scss';
import OutrunService from '../public/outrunService.svg';
import Benefits from '../public/benefitsClients.webp';
import Modal from '../components/contactUsModal';
import RelatedServices from '../components/relatedServices';
import Link from 'next/link';

export default function OutRunService() {
  const router = useRouter();
  const { t, } = useTranslation('outrunService');

  return (
    <Layout title={t('title')} lang={router.locale} route={router.route} isHeader isFooter>
      <ScrollButton scrollStepInPx='50' delayInMs='16.66' />

      <InfoSection
        title='Outrun Service'
        description='outrunServiceDescription'
        documentationLink='https://help.icdc.io/outrun-service/'
        lang={router.locale}
      />

      <div className={styles.outrunService} >
        <section className={styles.whatOutrun}>
          <div className={styles.whatOutrunImg}>
            <Image src={OutrunService} alt="Outrun Service" />
          </div>
          <h2>{t('whatIsOutrunService.title')}</h2>
          <p>{t('whatIsOutrunService.description')}</p>
        </section>
        <section className={styles.features}>
          <h2>{t('features.title')}</h2>
          <div className={styles.featuresList}>
            {functionOutrunServiceList.map((item, index) => (
              <div key={index}>
                <div className={styles.featuresItemImg}>
                  <Image src={item.img} alt="" />
                </div>
                <h3>{t(item.subtitle)}</h3>
                <p>{t(item.subdescription)}</p>
              </div>
            ))}
          </div>
        </section>
        <section className={styles.cases}>
          <h2>{t('cases.title')}</h2>
          <div className={styles.casesWrapper}>
            <ul>
              {caseList.map((item, index) => (
                <li key={index}>
                  <h3>{t(item.subtitle)}</h3>
                  <p>{t(item.subdescription)}</p>
                </li>
              ))}
            </ul>
            <div className={styles.casesImg}>
              <Image src={Benefits} alt="Benefits" />
            </div>
          </div>
        </section>
        <section className={styles.benefits}>
          <div className={styles.benefitsWrapper}>
            <h2>{t('benefits.title')}</h2>
            {benefitList.map((item, index) => (
              <div key={index} className={styles.benefitsItem}>
                <Image src={item.img} alt="" />
                <h3>{t(item.subtitle)}</h3>
                <p>{t(item.subdescription)}</p>
              </div>
            ))}
            <Link href={t('benefits.docUrl')}>
              <a>
                <button className={'btn white'}>{t('benefits.doc')}</button>
              </a>
            </Link>
          </div>
        </section>
        <section className={styles.cloudBenefits} >
          <h2>{t('benefitsCloud.title')}</h2>
          <div className={styles.benefitsList}>
            {new Array(3).fill('').map((_, index) =>
              <div key={index} className={styles.benefitsItem}>
                <h3>{t(`benefitsCloud.benefit${index + 1}.title`)}</h3>
                <p>{t(`benefitsCloud.benefit${index + 1}.description`)}</p>
              </div>
            )}
            <div>
            </div>
          </div>
        </section>
        <section className={styles.questions}>
          <h2>{t('contact.title')}</h2>
          <p>{t('contact.desc')}</p>
          <Modal lang={router.locale} blue />
        </section>
        <section>
          <RelatedServices services={relatedServices} />
        </section>
      </div>

    </Layout>
  );
};

export const getStaticProps = async ({ locale }) => ({
  props: {
    ...await serverSideTranslations(locale, ['outrunService', 'common']),
  },
});
